<nz-header nzJustify="center" class="header">
  <div nz-row class="nav-content">
    <div class="logo" nz-col nzXs="6" nzLg="8"></div>
    <div class="home-link" nz-col nz-col="6" nzXs="12" nzLg="8">
      <a href="https://www.bemum.co/">Bemum.co</a>
    </div>
  </div>
</nz-header>

<div class="center">
  <div nz-row>
    <h2 nz-col class="title-page">Créer un compte</h2>
  </div>
  <div nz-row>
    <div nz-col nzXs="24" class="regis-wrapper">
      <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
        <!-- prenom -->
        <nz-form-item>
          <nz-form-control nzErrorTip="Veuillez saisir votre nom de famille">
            <nz-input-group>
              <input type="text" nz-input formControlName="lastname" placeholder="Nom de famille" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <!-- nom -->
        <nz-form-item>
          <nz-form-control nzErrorTip="Veuillez saisir votre prénom">
            <nz-input-group>
              <input type="text" nz-input formControlName="firstname" placeholder="Prénom" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <!-- email -->
        <nz-form-item>
          <nz-form-control [nzErrorTip]="errorEmailTpl">
            <nz-input-group>
              <input type="email" nz-input formControlName="email" placeholder="E-mail" />
              <ng-template #errorEmailTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Veuillez saisir une adresse e-mail valide
                </ng-container>
                <ng-container *ngIf="control.hasError('emailExist')">
                  Cette adresse email est déjà associée à un compte BeMum
                </ng-container>
              </ng-template>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <!-- téléphone -->
        <nz-form-item>
          <nz-form-control nzErrorTip="Veuillez saisir un numéro de téléphone valide">
            <nz-input-group>
              <input type="text" nz-input formControlName="phoneNumber" placeholder="Téléphone" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <!-- mot de passe  -->
        <nz-form-item>
          <nz-form-control [nzErrorTip]="errorPasswordTpl">
            <nz-input-group>
              <input type="password" nz-input formControlName="password" placeholder="Mot de passe" />
              <ng-template #errorPasswordTpl let-control>
                <ng-container *ngIf="control.hasError('required')"> Veuillez saisir un mot de passe </ng-container>
                <ng-container *ngIf="control.hasError('pattern')">
                  Le mot de passe doit: <br />
                  - avoir au moins 8 caractères <br />
                  - inclure 3 des 4 catégories : minuscules, majuscules, chiffres, caractères spéciaux.
                </ng-container>
              </ng-template>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <!-- Corfirmation mot de passe  -->
        <nz-form-item>
          <nz-form-control [nzErrorTip]="errorTpl">
            <nz-input-group>
              <input
                type="password"
                nz-input
                formControlName="checkPassword"
                placeholder="Confirmer votre mot de passe"
              />
              <ng-template #errorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Merci de confirmer votre mot de passe
                </ng-container>
                <ng-container *ngIf="control.hasError('pattern')">
                  Le mot de passe doit: <br />
                  - avoir au moins 8 caractères <br />
                  - inclure 3 des 4 catégories : minuscules, majuscules, chiffres, caractères spéciaux.
                </ng-container>
                <ng-container *ngIf="control.hasError('confirm')">
                  Les deux mots de passe ne sont pas les mêmes.
                </ng-container>
              </ng-template>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <!-- button -->
        <div nzXs="24">
          <!-- <div class="error" *ngIf="error">{{ errorText }}</div> -->
          <button
            nz-button
            [nzType]="'primary'"
            [ngClass]="form.valid ? 'bemum-rose' : 'bemum-beige'"
            nzSize="large"
            [disabled]="form.invalid"
          >
            CRÉER UN COMPTE
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
